var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Message",
    d: "M467,2134a6,6,0,0,1,6,6v16a6,6,0,0,1-6,6H448.75l-6.75,6v-6h-1a6,6,0,0,1-6-6v-16a6,6,0,0,1,6-6h26m0-3H441a9.012,9.012,0,0,0-9,9v16a9.024,9.024,0,0,0,7,8.78V2168a3.012,3.012,0,0,0,1.771,2.74A3.105,3.105,0,0,0,442,2171a2.99,2.99,0,0,0,1.994-.76l5.9-5.24H467a9.012,9.012,0,0,0,9-9v-16a9.012,9.012,0,0,0-9-9Zm-11.5,17a1.5,1.5,0,1,1-1.5-1.5,1.5,1.5,0,0,1,1.5,1.5Zm10,0a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,465.5,2148Zm-19.875,0a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,445.625,2148Z",
    transform: "translate(-432 -2131)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.158b6fad27825e642417e1b601456046.svg";
export { ForwardRef as ReactComponent };